import { gql } from '@apollo/client';
import { UserInfo } from '../../fragments/user/user.fragments';

export const UPDATE_USER_ACCOUNT = gql`
  mutation updateUserAccount(
    $id: ID!
    $firstname: String
    $lastname: String
    $email: String
    $tel: String
  ) {
    updateUsersPermissionsUser(
      id: $id
      data: {
        firstname: $firstname
        lastname: $lastname
        email: $email
        tel: $tel
      }
    ) {
      data {
        attributes {
          ...Account
        }
      }
    }
  }
  ${UserInfo.fragments.account}
`;
